import './app/configurator/components/index';

export default () => {
};
